<template>
	<li class="has-child" :class="[className, label ? 'has-label' : '']">
		<span class="link" v-if="label"> {{ label }} </span>
		<ul class="sidenav__links" v-if="items && items.length > 0">
			<template v-if="showLanguageSwitcher">
				<SideNavLanguageSwitcher :label="languageSwitcher">
				</SideNavLanguageSwitcher>
			</template>

			<template v-for="(item, index) of items">
				<NavLink
					v-if="item.fields && item.fields.link"
					:key="`sidenavchild__link__${index}`"
					:fields="item.fields"
					class="sidenav-child__link"
				/>
				<li
					class="sidenav__links-wrapper"
					v-if="
						item.fields &&
						item.fields.subLinks &&
						item.fields.subLinks.length > 0
					"
				>
					<ul class="sidenav__links">
						<template v-for="(subLink, subIndex) of item.fields.subLinks">
							<NavLink
								v-if="subLink.fields && subLink.fields.link"
								:key="`sidenavchild__sub-link__${subIndex}`"
								:fields="subLink.fields"
								class="sidenav-child__sub-link"
							/>
						</template>
					</ul>
				</li>
			</template>
		</ul>
	</li>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const items = computed(() => props.fields?.items || []);
const label = computed(() => props.fields?.label?.value);
const className = computed(() => props.fields?.class?.value);
const languageSwitcher = computed(() => props.fields?.language_switcher?.value);
const showLanguageSwitcher = computed(
	() => props.fields?.show_language_switcher?.value
);
</script>
